var map = {
	"./Loading-Icon.gif": 73699,
	"./app-awareness-phone.png": 63866,
	"./app-modal-android@2x.png": 25885,
	"./app-modal-iphone@2x.png": 91241,
	"./app-promo-banner-background.png": 74923,
	"./box-prices/2-portions.png": 40998,
	"./box-prices/2-portions.webp": 10447,
	"./box-prices/4-portions.png": 48320,
	"./box-prices/4-portions.webp": 79597,
	"./box-prices/box-prices-hero.jpg": 79026,
	"./box-prices/couples-box.jpg": 99926,
	"./box-prices/family-box.jpg": 6657,
	"./box-prices/four-person-box.jpg": 34595,
	"./box-prices/two-person-box.jpg": 36909,
	"./discount-modal-header.jpg": 369,
	"./discount-softening-experiment-modal-image.jpg": 15431,
	"./earn-reward-background.jpg": 28429,
	"./five-recipes/five-recipes.png": 84195,
	"./food/cauli-mac-cheese.jpg": 69860,
	"./food/jamaican-squash-coconut-stew.jpg": 70548,
	"./food/sweet-potato-dal.jpg": 66732,
	"./food/sweet-potato-sag-aloo.jpg": 64190,
	"./gousto-box.jpg": 11882,
	"./gousto-boxes.jpg": 98215,
	"./gousto-welcome-journey-rollover.jpg": 43761,
	"./hungry-for-savings.png": 52277,
	"./icon-gbox.svg": 10654,
	"./icon-van.svg": 79487,
	"./menu/FebYouary_desktop.jpg": 21181,
	"./menu/FebYouary_mobile.jpg": 30319,
	"./menu/FebYouary_tablet.jpg": 32273,
	"./menu/default_desktop_no_click.png": 61445,
	"./menu/default_mobile_no_click.png": 91217,
	"./menu/default_tablet_no_click.png": 87679,
	"./menu/spottyTileBorder.png": 88795,
	"./my-gousto-pricing-modal.svg": 95672,
	"./pause-osr-modal-bg.jpg": 77425,
	"./product-placeholder.png": 88849,
	"./recipe-placeholder.png": 64480,
	"./red-rice-pattern.png": 11106,
	"./spinner.gif": 7516,
	"./zest-logo.svg": 6942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59174;